module.exports = __webpack_public_path__ + "61e2d96d01a7eba5ea3ec1bad7e736a8.woff2";